import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { ClockComponent } from '@components/clock'

@Component({
	selector: 'valet-service-monitoring-layout',
	template: `
		<header>
			<h1>Valet Service Monitoring</h1>
			<app-clock />
		</header>
		<section>
			<router-outlet />
		</section>
	`,
	styleUrl: './valet-service-monitoring-layout.component.scss',
	imports: [RouterOutlet, ClockComponent],
})
export class ValetServiceMonitoringLayoutComponent {}
